import React, { useState, useContext } from 'react';
import { SubmitButton } from '@nintendo/forms';
import { Button, Modal } from 'react-bootstrap';
import NinModal from '../../common/modal/NinModal';
import { submitActionMemo } from '../../../api/actionMemoWorkflowApi';
import ConfigContext from '../../../contexts/ConfigContext';
import { sendToast, formatAmDisplayString } from '../../../utils/displayUtils';

export interface AmSubmitModalProps {
    amId: number;
    amNumber: number;
    supNumber: number;
    toggleButton: JSX.Element;
    onSubmit?: () => void;
}

const AmSubmitModal = (props: AmSubmitModalProps) => {
    const config = useContext(ConfigContext);

    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <NinModal
            button={props.toggleButton}
            render={(toggleModal) => (
                <>
                    <Modal.Header>
                        <Modal.Title>Submit Action Memo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {error ? (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        ) : null}
                        <p>You are submitting this action memo.</p>
                        <p>
                            {' '}
                            Please review the Approvers & Viewers and attach any required supporting
                            documentation.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="button"
                            className="btn-outline-secondary mr-auto"
                            onClick={toggleModal}
                            disabled={isSubmitting}
                        >
                            Close
                        </Button>
                        <SubmitButton
                            data-testid="modal-submit-button"
                            isSubmitting={isSubmitting}
                            className="btn-primary"
                            buttonText="Confirm"
                            onClick={async () => {
                                try {
                                    setIsSubmitting(true);
                                    await submitActionMemo(config, props.amId);
                                    sendToast(
                                        <>
                                            Submitted Action Memo:{' '}
                                            <strong>
                                                {formatAmDisplayString(
                                                    props.amNumber,
                                                    props.supNumber,
                                                )}
                                            </strong>
                                        </>,
                                    );
                                    toggleModal();
                                    if (props.onSubmit) {
                                        setError('');
                                        props.onSubmit();
                                    }
                                } catch (e) {
                                    if (e instanceof Error) {
                                        setError(`Submit request failed: ${e.message}`);
                                    }
                                    setIsSubmitting(false);
                                }
                            }}
                        />
                    </Modal.Footer>
                </>
            )}
        />
    );
};

export default AmSubmitModal;
